import { ReactNode } from 'react';

import { cn } from 'styles';

import { Card, CardProps } from './Card';

import { StringNodeGuard } from '../helpers/OrStringNode';

type WrapperProps = Pick<CardProps, 'variant'>;

type TitledCardProps = {
  className?: string;
  contentClassName?: string;

  title?: ReactNode;
  titleClassName?: string;

  description?: ReactNode;
  descriptionClassName?: string;

  children?: ReactNode;

  header?: ReactNode;

  spacing?: 'normal' | 'tight';

  headerRightContent?: ReactNode;
} & WrapperProps;

const spacingClasses = {
  header: {
    normal: 'p-6 pb-4',
    tight: 'p-4 pb-2',
  },

  content: {
    normal: 'p-6 pt-0',
    tight: 'p-4 pt-0',
  },
};

export function TitledCard({
  className,
  contentClassName,
  title,
  children,
  description,
  header,
  variant,
  descriptionClassName,
  titleClassName,
  spacing = 'normal',
  headerRightContent,
}: TitledCardProps): JSX.Element {
  return (
    <Card className={className} variant={variant} spacing="none">
      {header ?? (
        <div className={cn('flex flex-wrap justify-between gap-4', spacingClasses.header[spacing])}>
          <div className="flex flex-col space-y-1.5">
            <StringNodeGuard node={title}>
              <h3
                className={cn('text-2xl font-semibold leading-none tracking-tight', titleClassName)}
              >
                {title}
              </h3>
            </StringNodeGuard>

            <StringNodeGuard node={description}>
              <p className={cn('text-sm text-muted-foreground', descriptionClassName)}>
                {description}
              </p>
            </StringNodeGuard>
          </div>

          {headerRightContent}
        </div>
      )}

      <div className={cn(spacingClasses.content[spacing], contentClassName)}>{children}</div>
    </Card>
  );
}
